import { getSupplierPrefixes } from './requests';

export default {
  getSupplierPrefixes,
};
